import React, { useState, useEffect, useRef } from 'react';
import API from '../utils/api';

function CnInput({ value, onChange, onBlur, placeholder, style }) {
  const composing = useRef(false);
  const [local, setLocal] = useState(value || '');
  useEffect(() => { if (!composing.current) setLocal(value || ''); }, [value]);
  return (
    <input value={local} placeholder={placeholder} style={style}
      onChange={e => { setLocal(e.target.value); if (!composing.current) onChange(e.target.value); }}
      onCompositionStart={() => { composing.current = true; }}
      onCompositionEnd={e => { composing.current = false; setLocal(e.target.value); onChange(e.target.value); }}
      onBlur={onBlur} />
  );
}

const defaultInputStyle = {
  width: '100%', padding: '10px 12px', fontSize: '15px',
  border: '1px solid #d9d9d9', borderRadius: '8px', boxSizing: 'border-box'
};
const chipStyle = (active) => ({
  padding: '4px 12px', fontSize: '13px', borderRadius: '14px',
  border: active ? '1px solid #1890ff' : '1px solid #d9d9d9',
  background: active ? '#e6f4ff' : '#fff',
  color: active ? '#1890ff' : '#666', cursor: 'pointer'
});

export default function HistoryPicker({ type, value, onChange, placeholder, style }) {
  const [history, setHistory] = useState([]);
  const refresh = () => API.get('/history', { params: { type } }).then(r => setHistory(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, [type]);
  const save = (v) => {
    if (v && v.trim()) API.post('/history', { type, value: v.trim() }).then(refresh).catch(() => {});
  };
  return (
    <div>
      <CnInput style={{ ...defaultInputStyle, ...style }} placeholder={placeholder} value={value}
        onChange={onChange} onBlur={() => save(value)} />
      {history.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
          {history.map(h => (
            <button key={h} type="button" style={chipStyle(value === h)} onClick={() => onChange(h)}>{h}</button>
          ))}
        </div>
      )}
    </div>
  );
}
